import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {Translate, I18n} from 'react-redux-i18n';
import { Dialog, TextArea, InputGroup, Checkbox } from '@blueprintjs/core';
import classnames from 'classnames';
import axios from 'axios';

import ebStyles from '../ExerciseBenchmark/Exercise.module.css';

import {
    closeEditContributionDialog
} from './MutualAidActions';

function EditBenchmarkContributionDialog({ onUpdated }) {
    
    const isEditBenchmarkContributionDialogOpen = useSelector((state) => state.mutualAid.isEditBenchmarkContributionDialogOpen)
    const benchmark = useSelector((state) => state.mutualAid.benchmark)
    const dispatch = useDispatch();
    
    const [state, setState] = useState({_id: "", name: "", description: "", categories: [], questions: [{title: "", answers: ["Yes", "No"]}]});
    const [categories, setCategories] = useState([]);
    const [error, setError] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    
    useEffect(()=>{
      (async ()=>{
        const response = await axios.get('/api/category', {
            headers: {
                'Authorization': window.localStorage.getItem("token")
            }
        })
        setCategories(response.data.categories);
      })();
    }, []);
    
    useEffect(()=>{
      if(!benchmark) return;
      const { _id, name, contribution: { description, categories }, questions } = benchmark;
      console.log("Setting state with benchmark", benchmark);
      setState({_id, name, description, categories, questions})
    }, [isEditBenchmarkContributionDialogOpen])
    
    function closeDialog() {
        setIsSubmitting(false);
        dispatch(closeEditContributionDialog());
    }
    
    async function handleSubmit() {
      try {
        setIsSubmitting(true);
        const response = await axios.patch('/api/companies/benchmarks/contribute', {
          ...state
        }, {
          headers: {
            'Authorization': window.localStorage.getItem("token")
          }
        });
        if(onUpdated && typeof onUpdated === 'function') onUpdated({...state, contribution: {description: state.description, categories: state.categories}});
        closeDialog();
      } catch (err) {
        console.error(err);
        setError("Something went wrong");
        setIsSubmitting(false);
      }
    }
    
    return (
      <Dialog
        isOpen={isEditBenchmarkContributionDialogOpen}
        onClose={closeDialog}
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        enforceFocus={true}
        usePortal= {true}
        title={<span style={{color: 'white'}}><Translate value="exercise.EditBenchmark" /></span>}
      >
        <div className="column" style={{padding: '20px 20px 0px 20px'}}>
            {
                error && <div>{error}</div>
            }
            <InputGroup
                onChange={(event)=>{event.persist(); setState((prevState)=>({...prevState, name: event.target.value}))}}
                placeholder={`Name (default: "${benchmark?.name}")`}
                value={state.name}
            />
            <TextArea
                onChange={(event)=>{
                    event.persist();
                    setState((prevState)=>({...prevState, description: event.target.value}));
                }}
                placeholder="Description"
                value={state.description}
                style={{margin: '5px 0px'}}
            />
            <span className="row wrap" style={{padding: '20px'}}>
            {
                categories.filter((category)=>!category.parent).map((category)=>(
                    <div style={{width: '200px', marginBottom: 30}} key={"div-"+category._id}>
                        <Checkbox 
                            key={category._id}
                            label={category.name} 
                            checked={state.categories.includes(category._id)} 
                            onChange={
                                (event)=>{
                                    event.persist();
                                    event.target.checked? 
                                    setState((prevState)=>({
                                      ...prevState,
                                      categories: prevState.categories.concat(category._id)
                                // to select parent cat as well: selectedCategories: prevState.selectedCategories.concat(category._id, ...prevState.categories.filter((cat)=>cat.parent === category._id).map((cat)=>cat._id))
                                
                                    }))
                                    : 
                                    setState((prevState)=>({...prevState, categories: prevState.categories.filter((cat)=> cat !== category._id)})) 
                                // to select parent cat as well: setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((cat)=> cat !== category._id && prevState.categories.find((c)=>c._id === cat).parent !== category._id)})) 
                                
                                }
                            }
                        />
                        <div style={{paddingLeft: '15px'}}>
                        {
                            categories
                            .filter((cat)=>cat.parent === category._id)
                            .map((cat)=>(
                                <Checkbox 
                                    key={cat._id}
                                    label={cat.name} 
                                    checked={state.categories.includes(cat._id)} 
                                    onChange={
                                        (event)=>{
                                            event.persist();
                                            event.target.checked? 
                                            setState((prevState)=>({...prevState, categories: prevState.categories.concat(cat._id, cat.parent)})) 
                                            : 
                                            setState((prevState)=>({...prevState, categories: prevState.categories.filter((word)=> word !== cat._id)})) 
                                        }
                                    }
                                />  
                            ))
                        }
                        </div>
                    </div>
                ))
            }
            </span>
            <div className="column col-sm-12" style={{paddingTop: 20, paddingBottom: 20}}>
            {
              state.questions.map((q, index)=>(
                <div key={"q-"+index} className={classnames(ebStyles.dialogBenchmarkQuestion)}>
                  <InputGroup
                    placeholder="Question"
                    value={q.title}
                    onChange={(event)=>{
                      event.persist();
                      setState((prevState)=>({
                        ...prevState,
                        questions: prevState.questions.reduce((acc, q, i) => {
                          if(index === i) {
                            q.title = event.target.value
                          }
                          acc.push(q);
                          return acc;
                        }, [])
                      }))
                    }}
                    rightElement={
                      <div className={classnames(ebStyles.actionBox)}>
                        <button
                          className={classnames("row", "centered", ebStyles.removeAnswer, "pointer", ebStyles.deleteBtn)}
                          onClick={()=>{
                            setState(
                              (prevState)=>({
                                ...prevState,
                                questions: prevState.questions.filter((filterQuestion, filterIndex)=>filterIndex !== index)
                              })
                            )
                          }}
                        ><i className={"fas fa-trash"} /></button>
                        <div className={classnames("column")}>
                          <i className="fas fa-angle-up pointer" onClick={()=>{
                            if(index === 0) return;
                            setState((prevState) => {
                              const [movable] = prevState.questions.splice(index, 1);
                              prevState.questions.splice(index - 1, 0, movable)
                              return {...prevState, questions: prevState.questions}
                            })
                          }} />
                          <i className="fas fa-angle-down pointer" onClick={()=>{
                            if(index === state.questions.length - 1) return;
                            setState((prevState) => {
                              const [movable] = prevState.questions.splice(index, 1);
                              prevState.questions.splice(index + 1, 0, movable)
                              return {...prevState, questions: prevState.questions}
                            })
                          }} />
                        </div>
                      </div>
                    }
                  />
                  {
                    q.answers.map((answer, aIndex) => (
                      <div key={"q-"+index+"-a-"+aIndex} className={classnames("row", ebStyles.answerContainer)}>
                        <InputGroup
                          placeholder="Answer"
                          value={answer}
                          className={classnames(ebStyles.answer)}
                          onChange={(event)=>{
                            event.persist();
                            setState((prevState)=>({
                                ...prevState,
                            questions: prevState.questions.reduce((acc, q, i) => {
                                if(index === i) {
                                  q.answers[aIndex] = event.target.value
                                }
                                acc.push(q);
                            return acc;
                            }, [])
                          }))}}
                        />
                        <div
                          className={classnames("row", "centered", ebStyles.removeAnswer, "pointer")}
                          onClick={()=>setState((prevState)=>{
                            const updated = Array.from(prevState.questions);
                            // remove the answer entry at this index
                            updated[index].answers.splice(aIndex, 1);
                            return { ...prevState, questions: updated }
                          })}
                        >x</div>
                        <div className={classnames("column")}>
                          <i className="fas fa-angle-up pointer" onClick={()=>{
                            if(aIndex === 0) return;
                            setState((prevState) => {
                              const [movable] = prevState.questions[index].answers.splice(aIndex, 1);
                              prevState.questions[index].answers.splice(aIndex - 1, 0, movable)
                              return {...prevState, questions: prevState.questions}
                            })
                          }} />
                          <i className="fas fa-angle-down pointer" onClick={()=>{
                            if(aIndex === state.questions[index].answers.length - 1) return;
                            setState((prevState) => {
                              const [movable] = prevState.questions[index].answers.splice(aIndex, 1);
                              prevState.questions[index].answers.splice(aIndex + 1, 0, movable)
                              return {...prevState, questions: prevState.questions}
                            })
                          }} />
                        </div>
                      </div>
                    ))
                  }
                  <button onClick={()=>setState((prevState)=>({...prevState, questions: prevState.questions.map((bq, mIndex) => {
                    if(mIndex === index) {
                      bq.answers.push("");
                    }
                    return bq;
                  }) }))}><Translate value="exercise.AddAnswer" /></button>
                </div>
              ))
            }
            </div>
            <button className={`btn btn-primary`} style={{marginTop: 10}} onClick={handleSubmit} disabled={isSubmitting}>
              <i className="fas fa-fw fa-share-alt"/> <Translate value="controls.Edit"/>
            </button>
        </div>
      </Dialog>
    )
}

export default EditBenchmarkContributionDialog;